export default {
  appUrl: `https://${process.env.NEXT_PUBLIC_APP_DOMAIN}`
}
